import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";

export interface StudioUser {
  id: string;
  studio_id: string;
}

export function useStudioUser() {
  const { getAuthToken } = useAuth();
  const [studioUser, setStudioUser] = useState<StudioUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchStudioUser() {
      try {
        const authToken = getAuthToken();
        if (!authToken) {
          setStudioUser(null);
          setLoading(false);
          return;
        }

        // Fetch the studio for the authenticated user
        const studioResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/supabase/studios/me`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (!studioResponse.ok) {
          throw new Error("Failed to fetch studio information");
        }

        const studioData = await studioResponse.json();
        if (studioData) {
          setStudioUser({
            id: studioData.owner_id,
            studio_id: studioData.id,
          });
        } else {
          setStudioUser(null);
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setLoading(false);
      }
    }

    fetchStudioUser();
  }, [getAuthToken]);

  return { studioUser, loading, error };
}
